// react
import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

// components
import Header from 'layout/MainLayout/Header';
import AspTags from 'asp';

const MainLayout = () => {
  const { pathname } = useLocation();
  const path = pathname.split('/');
  const isCart = ['', 'form', 'confirm', 'complete'].includes(path[1]);
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Header />
      <Outlet />
      {isCart && <AspTags />}
    </Suspense>
  );
};

export default MainLayout;
